import React, { Component, Fragment } from "react";
import { Route } from "react-router-dom";

import splashScreen from "./components/Splash/splash-screen";
import Login from "./components/Login/login";
import Install from "./components/Login/install";
import Main from "./components/Main/main";

import logo from "./images/logo.png";
import phone_ico from "./images/phone.png";
import chrome_ico from "./images/chrome.png";
import safari_ico from "./images/safari.png";

import "material-design-icons-iconfont/dist/material-design-icons.css";
import "materialize-css/dist/css/materialize.min.css";
import "materialize-css";

import {
  osVersion,
  isAndroid,
  isIOS,
  isChrome,
  isSafari,
  isMobile,
} from "react-device-detect";

class App extends Component {
  //#####################################################################################################

  constructor(props) {
    super(props);
    this.state = {
      screenOrientation: "portrait",
    };
  }

  setScreenOrientation = (e) => {
    if (navigator.userAgent.match(/Android/i)) {
      if (window.screen.orientation.angle === 0) {
        const oldOrientation = this.state.screenOrientation;
        this.setState({ screenOrientation: "portrait" });
        if (oldOrientation === "landscape") {
          if (!window.matchMedia("(display-mode: standalone)").matches) {
            window.location.reload();
          }
        }
      } else {
        this.setState({ screenOrientation: "landscape" });
      }
    }

    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      if (window.matchMedia("(orientation: portrait)").matches) {
        const oldOrientation = this.state.screenOrientation;
        this.setState({ screenOrientation: "portrait" });
        if (oldOrientation === "landscape") {
          if (!window.matchMedia("(display-mode: standalone)").matches) {
            window.location.reload();
          }
        }
      }
      if (window.matchMedia("(orientation: landscape)").matches) {
        this.setState({ screenOrientation: "landscape" });
      }
    }
  };

  componentDidMount() {
    if (navigator.userAgent.match(/Android/i))
      window.addEventListener("orientationchange", this.setScreenOrientation);
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i))
      window.addEventListener("resize", this.setScreenOrientation);
    this.setScreenOrientation();
  }

  componentWillUnmount() {
    if (navigator.userAgent.match(/Android/i))
      window.removeEventListener(
        "orientationchange",
        this.setScreenOrientation
      );
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i))
      window.removeEventListener("resize", this.setScreenOrientation);
  }

  //#####################################################################################################

  render() {
    //---------------------------------------------------------------------------------------------------
    var token = localStorage.getItem("token");
    var email = localStorage.getItem("email");
    var name = localStorage.getItem("name");
    var language = localStorage.getItem("language");

    var server = null;
    var sonido = localStorage.getItem("sound");
    var push = localStorage.getItem("push");
    var platform = localStorage.getItem("platform");
    var os_version = localStorage.getItem("os_version");
    var width = localStorage.getItem("width");
    var height = localStorage.getItem("height");
    var user_idDriver = localStorage.getItem("user_idDriver");
    var authKey = localStorage.getItem("key");

    if (width === "" || width === null)
      localStorage.setItem("width", window.innerWidth);
    if (height === "" || height === null)
      localStorage.setItem("height", window.innerHeight);
    if (platform === "" || platform === null)
      localStorage.setItem("platform", "");
    if (os_version === "" || os_version === null)
      localStorage.setItem("os_version", "0");
    if (sonido === "" || sonido === null) localStorage.setItem("sound", true);
    if (token === null) token = "";
    if (push === "" || push === null) localStorage.setItem("push", "");
    if (language === "" || language === null) {
      language = "en";
      localStorage.setItem("language", "en");
    }

    var debug = true; //process.env.NODE_ENV === "development" ? true : false;
    var seccion =
      localStorage.getItem("goToInspection") === "true"
        ? "inspections"
        : "home"; //home
    localStorage.setItem("goToInspection", false);
    //---------------------------------------------------------------------------------------------------

    let canShow = false;
    let isApp = false;
    let imagen;

    if (window.matchMedia("(display-mode: standalone)").matches) {
      isApp = true;
    }

    if (debug) isApp = true; //* ***********DEBUG*********** */

    if (isMobile) {
      if (osVersion !== null && osVersion !== "")
        localStorage.setItem("os_version", parseInt(osVersion));
      if (this.state.screenOrientation === "portrait") {
        if (isIOS) {
          if (isSafari) {
            canShow = true;
            localStorage.setItem("platform", "ios");
          } else {
            imagen = safari_ico;
          }
        }
        if (isAndroid) {
          if (isChrome) {
            canShow = true;
            localStorage.setItem("platform", "android");
          } else {
            imagen = chrome_ico;
          }
        }
      } else {
        imagen = logo;
      }
    } else {
      imagen = phone_ico;
    }

    if (canShow) {
      if (isApp) {
        if (token !== "") {
          return (
            <Fragment>
              <div className='container-fluid'>
                <Route
                  path='/'
                  render={(props) => (
                    <Main
                      {...props}
                      token={token}
                      email={email}
                      name={name}
                      language={language}
                      server={server}
                      label={seccion}
                      idDriver={user_idDriver}
                      authKey={authKey}
                    />
                  )}
                />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <div className='container-fluid'>
                <Route
                  path='/'
                  render={(props) => (
                    <Login
                      {...props}
                      language={language}
                      label={seccion}
                      debug={debug}
                    />
                  )}
                />
              </div>
            </Fragment>
          );
        }
      } else {
        return (
          <Fragment>
            <div className='container-fluid'>
              <Route
                path='/'
                render={(props) => (
                  <Install {...props} language={language} server={server} />
                )}
              />
            </div>
          </Fragment>
        );
      }
    } else {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <img src={imagen} alt='' style={{ width: "30%" }} />
        </div>
      );
    }
  }

  //#####################################################################################################
}

export default splashScreen(App);
